import { Button as AntdButton } from "antd";

function Button({
  id = null,
  className = "",
  disabled = false,
  type = "primary",
  htmlType = "button",
  onClick = () => { },
  children = null,
  size = "default",
  style = {},
}) {
  return (
    <AntdButton
      {...(id ? { id } : {})}
      className={className}
      disabled={disabled}
      type={type}
      htmlType={htmlType}
      onClick={onClick}
      size={size}
      style={style}
    >
      {children}
    </AntdButton>
  );
}

export default Button;
